import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styles from "./SpinningNumber.module.scss";
const ARRAY_OF_NUMBERS_FOR_ZERO_ANIMATION = [0, 3, 2, 1, 0];
const getArrayOfNumbers = (count) => {
    if (count === 0) {
        return ARRAY_OF_NUMBERS_FOR_ZERO_ANIMATION;
    }
    return Array.from({ length: count + 1 }, (_, i) => i).reverse();
};
export const SpinningNumber = ({ number, textClassName }) => {
    const numbersArray = useMemo(() => {
        return getArrayOfNumbers(number);
    }, [number]);
    return (_jsx("div", { className: styles.numberContainer, "data-number": number, "data-testid": "spinningNumber", children: numbersArray.map((item) => (_jsx("span", { className: textClassName, children: item }, item))) }));
};
//# sourceMappingURL=SpinningNumber.js.map